export const DESIGN_SYSTEMS = { WDS: 'wds', BASE_UI: 'baseUi' }

export const SUPPORTED_DESIGN_SYSTEMS = Object.values(DESIGN_SYSTEMS)
